import { Component, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { StepIndicatorService } from 'lib/ng2-sapmp/src/ui-components/step-indicator';
import { BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { AuthenticationService, UtilityService } from 'lib/ng2-sapmp/src/providers';
import { BulkWizardDataService } from './../bulk-wizard-data-service';
import { ANALYTICS_CONSTANTS } from 'config';

@Component({
  selector: 'app-bulk-users-action',
  templateUrl: './bulk-action.component.html',
  styleUrls: ['./../bulk-users.component.scss'],
  providers: [BulkWizardDataService]
})
export class BulkActionComponent implements OnInit {

  userAction: string;
  addRadio = false;
  continueFlag = true;
  reviewComponentSuccessMessage: string;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private stepindicatorService: StepIndicatorService,
    private bulkWizardDataService: BulkWizardDataService,
    private utilityService: UtilityService
  ) {
  }

  ngOnInit() {
    if (sessionStorage.getItem('bulk-sourcePreviousRoute') === null) {
      this.router.navigate(['/home']);
      return;
    }
    this.reviewComponentSuccessMessage = undefined;
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);
    this.stepindicatorService.setCurrentStep(this.activatedRoute.snapshot.url[0].path);
    this.userAction = '';
    this.bulkWizardDataService.createPageLoadProperties(this.router.routerState.snapshot.url,
      'Bulk User upload - Action',
      ANALYTICS_CONSTANTS.FRIENDLY_NAME_BULKUPLOAD_STEP1);
    this.reviewSuccess();
    this.bulkWizardDataService.tokenRefresh();
  }
  continueButton(selection: string) {
    this.setSuccessMessageUndefined();
    if (selection === 'add') {
      this.addRadio = true;
    } else {
      this.addRadio = false;
    }
    this.continueFlag = false;
  }

  cancel() {
    this.setSuccessMessageUndefined();
    // this.router.navigate([sessionStorage.getItem('bulk-sourcePreviousRoute')]);
    const parentUrl = this.utilityService.getParentUrl();
    this.router.navigate([parentUrl]);
  }

  continue() {
    this.setSuccessMessageUndefined();
    this.router.navigate(['/bulkUsers/bulk-upload'], { relativeTo: this.activatedRoute });
    sessionStorage.setItem('navigationUrl', '/bulkUsers/bulk-upload');
    // to check , for restrict direct url hit
    sessionStorage.setItem('bulk-previousRoute', '/bulkUsers/bulk-action');
    // ag4104 - Already we are using breadcrumb service. Do we need this ?
  }

  reviewSuccess() {
    if (this.utilityService.getSuccessMessage()) {
      this.reviewComponentSuccessMessage = this.utilityService.getSuccessMessage();
      this.utilityService.loadFocusOnTop();
    } else {
      this.setSuccessMessageUndefined();
    }
  }

  private setSuccessMessageUndefined() {
    this.reviewComponentSuccessMessage = undefined;
    this.utilityService.setSuccessMessage(undefined);
  }
}
